(function(){
  'use strict';
  if(window.__SHConversionV101)return;
  window.__SHConversionV101=true;
  var mobileQuery=window.matchMedia('(max-width:900px)');
  var purchaseObserver=null;
  var purchaseSeen=new Map();
  function collectCards(root,selector){
    var cards=[];
    if(!root)return cards;
    if(root.matches&&root.matches(selector))cards.push(root);
    if(root.closest){var ancestor=root.closest(selector);if(ancestor&&cards.indexOf(ancestor)===-1)cards.push(ancestor);}
    if(root.querySelectorAll)root.querySelectorAll(selector).forEach(function(card){if(cards.indexOf(card)===-1)cards.push(card);});
    return cards;
  }
  function enableQuickAdd(scope){
    var root=scope||document;
    if(document.body&&document.body.classList.contains('template-cart'))return;
    if(root.matches&&root.matches('[data-quick-add-enabled]'))root.dataset.quickAddEnabled='true';
    if(root.querySelectorAll)root.querySelectorAll('[data-quick-add-enabled]').forEach(function(el){el.dataset.quickAddEnabled='true';});
  }
  function injectUniversalQuick(scope){
    var root=scope||document;
    collectCards(root,'[data-sh-uc-card]').forEach(function(card){
      if(card.classList.contains('is-sold-out')||card.querySelector('[data-sh-uc-quick]'))return;
      var media=card.querySelector('.sh-uc-card__media'),variantId=card.dataset.selectedVariantId;if(!media||!variantId)return;
      var button=document.createElement('button');button.type='button';button.className='sh-uc-card__quick';button.dataset.shUcQuick='';button.dataset.selectedVariantId=variantId;button.setAttribute('aria-label','Quick add');button.innerHTML='<span>Quick add</span>';media.appendChild(button);
    });
  }
  function injectFurnitureQuick(scope){
    var root=scope||document;
    collectCards(root,'.sh-furn__card[data-handle]').forEach(function(card){
      if(card.querySelector('[data-quick-add]')||card.classList.contains('is-sold-out')||card.querySelector('.sh-furn__sold'))return;
      var media=card.querySelector('.sh-furn__media');if(!media)return;
      var button=document.createElement('button');button.type='button';button.className='sh-furn__quick';button.dataset.quickAdd=card.dataset.handle;button.textContent='Quick add';button.setAttribute('aria-label','Quick add');media.appendChild(button);
    });
  }
  function injectDynamicCollectionQuick(scope){
    var root=scope||document;
    [
      {card:'.sh-lec__card[data-handle]',media:'.sh-lec__media',button:'sh-lec__quick-button',sold:'.sh-lec__sold',group:false},
      {card:'.sh-te__card[data-handle]',media:'.sh-te__media',button:'sh-te__quick-button',sold:'.sh-te__sold',group:true},
      {card:'.sh-ha__card[data-handle]',media:'.sh-ha__media',button:'sh-ha__quick-button',sold:'.sh-ha__sold',group:true},
      {card:'.sh-tx__card[data-handle]',media:'.sh-tx__media',button:'sh-tx__quick-button',sold:'.sh-tx__sold',group:true}
    ].forEach(function(cfg){
      collectCards(root,cfg.card).forEach(function(card){
        if(card.querySelector('[data-sh-quick]')||(cfg.sold&&card.querySelector(cfg.sold)))return;
        var media=card.querySelector(cfg.media),handle=card.dataset.handle;if(!media||!handle)return;
        var button=document.createElement('button');button.type='button';button.className=cfg.button;button.dataset.shQuick=handle;
        if(cfg.group&&card.dataset.group)button.dataset.shQuickGroup=card.dataset.group;
        button.textContent='Quick add';button.setAttribute('aria-label','Quick add');media.appendChild(button);
      });
    });
  }
  function earlyEnhance(scope){enableQuickAdd(scope);injectUniversalQuick(scope);injectFurnitureQuick(scope);injectDynamicCollectionQuick(scope);}
  function boot(scope){earlyEnhance(scope||document);}
  var earlyObserver=new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      if(m.target&&m.target.nodeType===1)earlyEnhance(m.target);
      m.addedNodes.forEach(function(node){if(node.nodeType===1)earlyEnhance(node);});
    });
  });
  earlyObserver.observe(document.documentElement,{childList:true,subtree:true});
  earlyEnhance(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});else boot(document);
  document.addEventListener('shopify:section:load',function(event){window.requestAnimationFrame(function(){boot(event.target||document);});});
  window.addEventListener('pageshow',function(){window.requestAnimationFrame(function(){boot(document);});});
})();
